'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classNameFix = exports.getPassThroughProps = exports.I18nCommonMixin = exports.commonPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _unescapedText = require('I18n/utils/unescapedText');

var _unescapedText2 = _interopRequireDefault(_unescapedText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var commonPropTypes = exports.commonPropTypes = {
  message: _react.PropTypes.string.isRequired,
  options: _react.PropTypes.object,
  useGap: _react.PropTypes.bool
};

var I18nCommonMixin = exports.I18nCommonMixin = {
  getDefaultProps: function getDefaultProps() {
    return {
      options: {},
      useGap: false
    };
  },
  _getValue: function _getValue() {
    var unescapeOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _props = this.props,
        useGap = _props.useGap,
        message = _props.message,
        options = _props.options;

    var value = unescapeOptions ? (0, _unescapedText2.default)(message, options) : _I18n2.default.text(message, options);
    if (useGap === true) {
      value = ' ' + value + ' ';
    }
    return value;
  },


  statics: {
    isI18nElement: true
  }
};

var getPassThroughProps = exports.getPassThroughProps = function getPassThroughProps(allProps) {
  var localeOverwrite = allProps.options && allProps.options.locale;
  var result = {
    'data-locale-at-render': localeOverwrite || _I18n2.default.locale,
    'data-key': allProps.message
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(allProps)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var propKey = _step.value;

      if (['message', 'options', 'useGap'].indexOf(propKey) < 0) {
        result[propKey] = allProps[propKey];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
};

var classNameFix = exports.classNameFix = function classNameFix(props) {
  var className = props.className,
      classProp = props.class,
      restProps = _objectWithoutProperties(props, ['className', 'class']);

  if (className && !classProp) {
    return _extends({
      class: className
    }, restProps);
  }

  return props;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.433/js/components/utils.js
// module id = 237
// module chunks = 3 4 5